import { useOrganization } from '@monorepo/shared/hooks/useOrganization';
import { generateSlug, RandomWordOptions } from 'random-word-slugs';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

/** trying to avoid anything judgemental, so not using adjectives, and removing nouns like countries and religion */
function generateRandomSlugSafeForUsersToSee() {
  const options: RandomWordOptions<3> = {
    partsOfSpeech: ['noun', 'noun', 'noun'],
    categories: {
      noun: [
        'animals',
        'education',
        'family',
        'food',
        'health',
        'media',
        'science',
        'sports',
        'technology',
        'thing',
        'time',
        'transportation',
      ],
    },
  };

  return generateSlug(3, options);
}

export function sluggifyOrgName(orgName: string): string {
  return orgName
    .trim()
    .toLowerCase()
    .normalize('NFKD') // split accented letters into base + accent
    .replace(/[\u0300-\u036f]/g, '') // remove accent marks
    .replace(/['’]/g, '') // remove apostrophes (e.g. "Bert's" -> "berts", not "bert-s-")
    .replace(/—/g, '-') // replace em-dashes with hyphens
    .replace(/[^a-z0-9]+/g, '-') // replace punctuation with hyphens
    .replace(/-+/g, '-') // collapse duplicate hyphens
    .replace(/^-+|-+$/g, ''); // remove leading/trailing hyphens
}

export function useRandomFormTemplateSlug() {
  const { organizationId } = useParams();
  const { organization } = useOrganization({ organizationId });

  const slug = useMemo(() => {
    if (!organization) return '';
    const orgNameSlug = sluggifyOrgName(organization.name);
    return `${orgNameSlug}-${generateRandomSlugSafeForUsersToSee()}`;
  }, [organization]);

  return slug;
}
